import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/style.css";
import { auth, db } from "./firebase";
import { Element, scroller } from "react-scroll";
import firebase from "firebase/compat/app";

const Chapter5_5 = () => {
  const navigate = useNavigate();
  const [selectedAnswers, setSelectedAnswers] = useState({ q1: "", q2: "" });
  const [error, setError] = useState("");
  const [userId, setUserId] = useState(null);

  const questions = [
    {
      question:
        "Frage 1: Was ist das Hauptziel von Unified Endpoint Management (UEM)?",
      options: [
        {
          value: "A",
          label:
            "Die zentrale Verwaltung und Sicherung aller Endpunkte, einschließlich mobiler Geräte, Desktops und IoT-Geräte.",
        },
        {
          value: "B",
          label: "Die Verwaltung von Smart-Home-Systemen.",
        },
      ],
      correct: "A",
    },
    {
      question:
        "Frage 2: Warum ist 5G wichtig für die Zukunft der Endpunkttechnologie?",
      options: [
        {
          value: "A",
          label:
            "Die Geschwindigkeit von 5G lässt IoT-Systeme schneller miteinander kommunizieren. ",
        },
        {
          value: "B",
          label:
            "Die Geschwindigkeit von 5G erlaubt es Endpunkten, Daten schneller zu analysieren.",
        },
      ],
      correct: "A",
    },
  ];
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      scroller.scrollTo(location.hash.substring(1), {
        duration: 500,
        smooth: true,
        offset: -50,
      });
    }
  }, [location]);
  
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        setUserId(user.uid); 
      } else {
        console.error("Kein authentifizierter Benutzer gefunden");
        setError("Benutzer ist nicht authentifiziert");
        navigate("/login"); 
      }
    });

    
    return () => unsubscribe();
  }, [navigate]);

  
  useEffect(() => {
    console.log("Aktuelle userId in 5_5.js:", userId);
  }, [userId]);

  const handleLogout = () => {
    
    auth
      .signOut()
      .then(() => {
        
        window.location.href = "/login"; 
      })
      .catch((error) => {
        console.error("Logout fehlgeschlagen:", error);
      });
  };

  const handleAnswerChange = (questionIndex, value) => {
    setSelectedAnswers((prev) => ({
      ...prev,
      [questionIndex]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const correctAnswers = questions.every(
      (q, index) => selectedAnswers[index] === q.correct
    );

    if (correctAnswers) {
      try {
        if (!userId) {
          console.error("userId ist nicht definiert");
          setError("Ein Fehler ist aufgetreten.");
          return;
        }

        
        const userDoc = await db.collection("users").doc(userId).get();

        console.log("userDoc:", userDoc.exists); 

        if (userDoc.exists) {
          
          await db
            .collection("users")
            .doc(userId)
            .update({
              lastChapter: "5_5",
              completedChapters:
                firebase.firestore.FieldValue.arrayUnion("5_5"),
            });
          console.log("Dokument aktualisiert mit Kapitel 5_5.");
        } else {
          
          await db
            .collection("users")
            .doc(userId)
            .set({
              lastChapter: "5_5",
              completedChapters: ["5_5"],
            });
          console.log("Dokument erstellt mit Kapitel 5_5");
        }

        navigate("/6_1"); 
      } catch (error) {
        console.error("Fehler beim Aktualisieren des Fortschritts:", error);
        setError("Ein Fehler ist aufgetreten. Versuche es später erneut.");
      }
    } else {
      setError("Die Antworten sind nicht korrekt. Versuche es erneut.");
    }
  };
  return (
    <div className="container">
      <div className="container py-5">
        <img
          src="/images/zebbs_Logo.svg"
          class="d-block mx-auto mb-4"
          alt=""
          style={{ width: "20%" }}
        />
        <div className="d-flex justify-content-between align-items-center mb-5 p-3 bg-body-tertiary rounded-3">
          {/* Breadcrumbs */}
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb breadcrumb-chevron mb-0">
              {/* Startseite (Home) */}
              <li className="breadcrumb-item">
                <Link className="link-body-emphasis" to="/course-overview">
                  <i className="bi bi-house-door-fill"></i>
                  <span className="visually-hidden">Home</span>
                </Link>
              </li>

              {/* Library Link */}
              <li className="breadcrumb-item">
                <Link
                  className="link-body-emphasis fw-semibold text-decoration-none"
                  to="/course-overview"
                >
                  5. Endpunktsicherheit
                </Link>
              </li>

              {/* Aktuelle Seite */}
              <li className="breadcrumb-item active" aria-current="page">
                UEM und Endpunktintelligenz
              </li>
            </ol>
          </nav>

          {/* Logout-Button */}
          <button className="btn btn-outline-dark" onClick={handleLogout}>
            Logout
          </button>
        </div>

        <div
          className="p-5 m-0 rounded-3"
          style={{
            position: "relative",
            backgroundColor: "#009fe0",
            margin: "25px",
            textAlign: "center",
          }}
        >
          <h3 className="text-center p-5">Kapitel 5: Endpunktsicherheit</h3>
          <h2 className="text-center p-3">UEM und Endpunktintelligenz</h2>
          <img
            src="/images/uem.webp"
            alt="UEM"
            style={{ position: "relative", maxWidth: "25%", height: "auto" }}
          />
        </div>

        <div className="p-5 text-center">
          <Element name="uem">
            <h3 className="p-5">Was ist Unified Endpoint Management (UEM)?</h3>
            <p className="col-lg-11 mx-auto">
              Unified Endpoint Management (UEM) ist eine Technologie, die es
              Unternehmen ermöglicht,{" "}
              <strong>alle Endpunkte ihrer IT-Infrastruktur </strong> –
              einschließlich Smartphones, Tablets, Laptops, Wearables wie z. B. 
              Smartwatches, Desktop-PCs und IoT-Geräten – zentral zu verwalten
              und abzusichern. Es stellt eine Weiterentwicklung von Mobile
              Device Management (MDM) und Enterprise Mobility Management (EMM)
              dar, indem es Sicherheits- und Verwaltungsfunktionen auf einer
              einzigen Plattform vereint. Ziel ist es, einheitliche Richtlinien
              umzusetzen, den Verwaltungsaufwand zu reduzieren und eine
              konsistente IT-Sicherheitsstrategie zu etablieren.
            </p>

            <p className="col-lg-9 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-danger rounded-2">
              <img
                src="/images/fact.svg"
                alt="Transparent"
                style={{
                  position: "relative",
                  maxWidth: "8%",
                  height: "auto",
                }}
              />
              Laut einer Umfrage von Gartner 2024 nutzen über 80% der
              Unternehmen mit mehr als 1.000 Mitarbeitern bereits eine
              UEM-Lösung oder planen die Einführung in den nächsten zwei Jahren.
            </p>
          </Element>
        </div>
      </div>

      <div className="grey-section">
        <div className="container p-5">
          <div className="p-5 text-center">
            <h3 className="p-5">
              Ganzheitliche Lösung zur Verwaltung und Absicherung sämtlicher
              Endpunkte:
            </h3>
            <p className="col-lg-11 mx-auto">
              UEM vereint Sicherheits- und Verwaltungsfunktionen auf einer
              einzigen Plattform und ermöglicht so die effiziente Durchsetzung
              von Sicherheitsstandards und die Abwehr moderner Bedrohungen.
              <br />
              <br />
              <strong>Zentrale Steuerung: </strong>
              UEM vereint die Verwaltung von Endpunkten unterschiedlicher Typen
              und Betriebssysteme. Egal, ob es sich um ein Laptop im Homeoffice,
              ein Smartphone im Außendienst oder IoT-Geräte in der Produktion
              handelt: Alle Endpunkte werden über dieselben Richtlinien und
              Standards gesichert.
              <br />
              <br />
              <strong>Proaktiver Schutz: </strong>
              UEM bietet automatisierte Sicherheitsmaßnahmen, wie z. B. die
              Implementierung von Software-Updates und das Schließen von
              Sicherheitslücken. Funktionen wie Verhaltensanalyse und
              Anomalieerkennung ermöglichen eine frühzeitige Identifikation und
              Eindämmung von Bedrohungen.
              <br />
              <br />
              <strong>Flexibilität und Skalierbarkeit: </strong>
              Hybride Arbeitsmodelle und neue Technologien wie AR (Augmented
              Reality) und VR (Virtual Reality)-Geräte werden von UEM problemlos
              integriert. Die Plattform bleibt skalierbar, um mit wachsenden
              Anforderungen und neuen Gerätetypen Schritt zu halten.
              <br />
              <br />
              <strong>Reaktionsfähigkeit bei Sicherheitsvorfällen: </strong>
              Im Ernstfall ermöglicht UEM schnelle Maßnahmen wie die Isolierung
              kompromittierter Geräte, die Analyse von Sicherheitsvorfällen und
              das Entfernen sensibler Daten per Remote-Löschung. Dies schützt
              Unternehmensressourcen effektiv vor größeren Schäden.
            </p>
            <p className="col-lg-9 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-danger rounded-2">
              <img
                src="/images/fact.svg"
                alt="Transparent"
                style={{
                  position: "relative",
                  maxWidth: "8%",
                  height: "auto",
                }}
              />
              Unternehmen berichten von einer Reduktion der IT-Verwaltungskosten
              um bis zu 25%, nachdem sie eine zentrale UEM-Plattform eingeführt
              haben. Die Einsparungen resultieren aus automatisierten Prozessen
              und der Abschaffung mehrerer separater Verwaltungstools.
            </p>
          </div>
        </div>
      </div>

      <div className="white-section">
        <div className="container p-5">
          <div className="p-5 text-center">
            <h3 className="p-5">5G und Endpunkte</h3>

            <p className="col-lg-11 mx-auto">
              5G steht für die fünfte Generation der Mobilfunktechnologie und
              ist der Nachfolger von 4G/LTE. Es bietet deutlich höhere
              Geschwindigkeiten, geringere Latenzzeiten und eine größere
              Kapazität, um mehr Geräte gleichzeitig zu verbinden. 5G ist daher
              ideal dafür ausgelegt, die Anforderungen IoT-Systeme zu erfüllen.
              <br />
              <br />
              Durch die <strong> extrem hohe Geschwindigkeiten </strong> von bis
              zu 10 Gbit/s, eine Latenz von unter einer Millisekunde und die
              Möglichkeit, Millionen von Geräten gleichzeitig zu verbinden
              können Endpunkte deutlich schneller miteinander kommunizieren. Diese Vorteile
              machen Endpunkte viel leistungsfähiger.
              <br />
              <br />
              Die Geschwindigkeit von 5G ermöglicht auch den Einsatz{" "}
              <strong> datenintensiver Anwendungen </strong>, wie z. B. AR- und
              VR-Geräte oder autonome Fahrzeuge, die kontinuierlich Daten
              austauschen. Die geringe Latenz sorgt dafür, dass Endpunkte nahezu
              in Echtzeit reagieren können, was in Bereichen wie der Telemedizin
              oder der industriellen Automatisierung entscheidend ist. Zudem
              verbessert die große Kapazität von 5G die Effizienz in Smart
              Cities, wo zahlreiche Endpunkte wie Verkehrs- und Umweltsensoren
              gleichzeitig Daten senden.
              <br />
              <br />
              Eine Schlüsseltechnologie von 5G, das{" "}
              <strong> Network Slicing </strong>, ermöglicht dedizierte
              Netzwerksegmente für spezifische Anwendungen. Dabei wird ein
              physisches Mobilfunknetz in mehrere virtuelle, unabhängige
              Netzwerke unterteilt. Jedes dieser „Slices“ kann individuell
              konfiguriert werden, um die spezifischen Anforderungen
              verschiedener Anwendungen oder Dienste zu erfüllen. Damit können
              Endpunkte besser geschützt und Ressourcen gezielt verteilt werden.
            </p>
          </div>
        </div>
      </div>

      <div className="white-section">
        <div className="container p-5">
          <div
            className="safe rounded-2 text-center"
            style={{ backgroundColor: "#fec748" }}
          >
            <img
              src="/images/abwehr.svg"
              alt="Abwehr"
              style={{
                position: "relative",
                maxWidth: "7%",
                height: "auto",
              }}
            />
            <h3 className="p-5">
              Künstliche Intelligenz und Automatisierung = Endpunktintelligenz
            </h3>
            <p className="col-lg-11 mx-auto">
              Die Integration von Künstlicher Intelligenz (KI) und
              Automatisierung in Endpunkten verändert deren Rolle grundlegend:
              Aus passiven Geräten, die nur Befehle empfangen und ausführen,
              werden aktive Akteure, die selbstständig Daten analysieren,
              Entscheidungen treffen und Prozesse steuern können.
              <br />
              <br />
              Ein zentraler Aspekt der KI-Integration ist die Fähigkeit von
              Endpunkten, sich an ihre Umgebung und ihre Benutzer anzupassen.{" "}
              <strong> Selbstlernende Algorithmen </strong> können Daten direkt
              auf dem Endpunkt analysieren, Muster erkennen und daraus optimale
              Handlungen ableiten – ohne dass diese Daten zunächst an zentrale
              Server gesendet werden müssen. Beispielsweise könnten dann smarte
              Überwachungskameras verdächtige Bewegungen erkennen und in
              Echtzeit Warnmeldungen an Sicherheitsteams senden, ohne ständig
              riesige Datenmengen ins Backend hochzuladen. Dadurch wird die
              Latenz reduziert und die Effizienz des Systems gesteigert.
              <br />
              <br />
              Ein weiterer Vorteil von KI-gestützten Endpunkten ist die
              Fähigkeit zur <strong> prädiktiven Analyse. </strong> In
              industriellen Anwendungen könnten Sensoren in Maschinen Anomalien
              erkennen, die auf einen möglichen Ausfall hinweisen. Diese
              Informationen ermöglichen es Unternehmen, Wartungsarbeiten gezielt
              und rechtzeitig durchzuführen, bevor es zu teuren Ausfällen kommt.
              Diese Form der <strong> Predictive Maintenance </strong> wird
              durch Machine-Learning-Modelle möglich, die auf historischen und
              Echtzeitdaten trainiert sind.
              <br />
              <br />
              Auch die Automatisierung spielt eine Schlüsselrolle in der
              Weiterentwicklung von Endpunkten. Endpunkte können dank KI nicht
              nur eigenständig Entscheidungen treffen, sondern diese auch ohne
              menschliches Eingreifen umsetzen. Ein Beispiel dafür ist die{" "}
              <strong> intelligente Energieverwaltung </strong> in Smart Homes:
              Thermostate passen sich automatisch an die Anwesenheit der
              Bewohner, die Tageszeit oder Wetterbedingungen an. Diese
              Automatisierungen sparen Energie und bieten gleichzeitig mehr
              Komfort.
              <br />
              <br />
              In der Zukunft wird sich die Rolle der KI in Endpunkten noch
              weiter ausdehnen. Es wird erwartet, dass Generative KI Endpunkte
              dazu befähigt, kreative Lösungen für komplexe Probleme zu finden.
              Für die Produktion, die Logistik oder im Kundenservice. Zum
              Beispiel könnten autonome Lieferdrohnen nicht nur Pakete
              ausliefern, sondern auch eigenständig die optimale Route unter
              Berücksichtigung von Wetterbedingungen und Verkehrsaufkommen
              planen.
              <br />
              <br />
              <strong>Edge Computing, </strong> das die Verarbeitung von Daten
              direkt am Endpunkt ermöglicht und nicht mehr erst die Daten ins
              Backend senden muss, verstärkt den Effekt von KI und
              Automatisierung zusätzlich. Die Daten werden also nicht mehr in zentralen Rechenzentren oder der Cloud verarbeitet, sondern möglichst nah an der Quelle - also direkt am "Rand" (Edge) des Netzwerks. Edge-fähige Endpunkte können Aufgaben
              wie Bilderkennung, Sprachverarbeitung oder Datensortierung lokal
              erledigen, was nicht nur die Geschwindigkeit erhöht, sondern auch
              Datenschutzvorgaben unterstützt, da z. B. weniger Daten in die
              Cloud hochgeladen werden müssen. Dies ist besonders in Bereichen
              wie der Telemedizin relevant, wo sensible Patientendaten direkt
              auf medizinischen Endpunkten verarbeitet werden.
            </p>
            <p className="col-lg-9 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-danger rounded-2">
              <img
                src="/images/fact.svg"
                alt="Transparent"
                style={{
                  position: "relative",
                  maxWidth: "8%",
                  height: "auto",
                }}
              />
              MarketsandMarkets schätzt den globalen Edge-Computing-Markt auf 168,40 Mrd. USD (2025) mit einer Prognose von 249,06 Mrd. USD bis 2030.
            </p>
          </div>
        </div>

        {/* Fragenteil */}
        <div className="container pt-5 my-5">
          <div className="text-center m-4">
            <h2>Überprüfe dein Wissen</h2>
            <p className="col-lg-11 mx-auto">
              Mit den richtigen Antworten kommst du weiter!
            </p>
          </div>
          <div className="row justify-content-center">
            <div className="col-md-11 text-start">
              <form onSubmit={handleSubmit}>
                {questions.map((question, index) => (
                  <div key={index} className="mb-4">
                    <p className="fs-4">{question.question}</p>{" "}
                    {question.options.map((option) => (
                      <div key={option.value} className="form-check">
                        <input
                          className="form-check-input me-2"
                          type="radio"
                          name={`question${index}`}
                          value={option.value}
                          checked={selectedAnswers[index] === option.value}
                          onChange={() =>
                            handleAnswerChange(index, option.value)
                          }
                        />
                        <label className="form-check-label fs-5">
                          {option.label}
                        </label>{" "}
                      </div>
                    ))}
                  </div>
                ))}
                {error && <p className="text-danger">{error}</p>}
                <div className="text-center">
                  <button type="submit" className="btn btn-primary">
                    überprüfen
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* Ende Fragenteil */}
      </div>
    </div>
  );
};

export default Chapter5_5;
